import React from 'react';
import { Box, Typography } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { ToiletCounterWrapperBox, ToiletCountItemBox } from './ToiletOptions.styles';

interface ToiletOptionsProps {
  showCaption?: boolean;
}
const ToiletOptions: React.FC<ToiletOptionsProps> = ({ showCaption = true }) => {
  return (
    <Box
      px={2}
      py={showCaption ? 2 : 1}
      borderTop={showCaption ? '1px solid #ddd' : undefined}
      sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
    >
      {showCaption && (
        <Typography variant="caption" fontWeight={600}>
          Options:
        </Typography>
      )}
      <Typography
        variant={showCaption ? 'h5' : 'body2'}
        fontWeight={400}
        color="text.primary"
        sx={{ fontSize: showCaption ? undefined : 14 }}
      >
        For these child events there will be an option to choose a number like it is shown below:
      </Typography>

      <ToiletCounterWrapperBox>
        <ToiletCountItemBox>
          <Remove sx={{ color: 'white' }} />
        </ToiletCountItemBox>
        <Box
          sx={{
            flex: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
          }}
        >
          <Typography variant="body1">3</Typography>
        </Box>
        <ToiletCountItemBox>
          <Add sx={{ color: 'white' }} />
        </ToiletCountItemBox>
      </ToiletCounterWrapperBox>
    </Box>
  );
};
export default ToiletOptions;
